/* eslint max-classes-per-file: 0 */

import {
  PublicationStorage as Data,
  PublicationStorageCollection as Collection,
} from '@/typings/api/Publication'
import { StorageApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class StorageTransformerParams extends TransformerParams {
}

export class StorageAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new StorageTransformerParams();
}
